<rt-dropdown>
  <rt-dropdown-header *ngIf="header">
    {{ header }}
  </rt-dropdown-header>
  <div #scrollWrap rtScrollable class="scroll-wrap">
    <rt-dropdown-item
      *ngFor="let item of items; trackBy: trackByItem"
      (click)="select.emit(item.value)"
    >
      <rt-icon prefix *ngIf="item.icon" [name]="item.icon"> </rt-icon>
      {{ item.option }}
    </rt-dropdown-item>
  </div>
</rt-dropdown>
